import { useState } from 'react'

import cn from 'classnames'
import { Link } from 'react-router-dom'

import logoFull from '@/assets/logo_full.png'

import { HeaderProps } from './Header.types'

export const Header = (props: HeaderProps) => {
    const { className } = props
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <header className={cn('sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm', className)}>
            <div className='px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8'>
                <div className='relative flex items-center justify-between'>
                    <Link to='/' aria-label='Nexly' title='Nexly' className='inline-flex items-center'>
                        <img src={logoFull} alt='Nexly' className='h-10'/>
                    </Link>
                    <ul className='flex items-center hidden space-x-8 lg:flex'>
                        <li>
                            <a href='/#features' aria-label='Features' title='Features' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary'>
                                Features
                            </a>
                        </li>
                        <li>
                            <Link to='/contacts' aria-label='Contact' title='Contact' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary'>
                                Contact
                            </Link>
                        </li>
                        <li>
                            <a href='/#pricing' aria-label='Pricing' title='Pricing' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary'>
                                Pricing
                            </a>
                        </li>

                        <li>
                            <Link
                                to='/contacts'
                                className='inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-primary hover:bg-primary-hover focus:shadow-outline focus:outline-none'
                                aria-label='Contact us'
                                title='Contact us'
                            >
                                Contact us
                            </Link>
                        </li>
                    </ul>
                    <div className='lg:hidden'>
                        <button
                            aria-label='Open Menu'
                            title='Open Menu'
                            className='p-2 -mr-1 transition duration-200 rounded focus:outline-none focus:shadow-outline hover:bg-gray-100 focus:bg-gray-100'
                            onClick={() => { setIsMenuOpen(!isMenuOpen) }}
                        >
                            {isMenuOpen ? (
                                <svg className='w-5 text-gray-600' viewBox='0 0 24 24' fill='currentColor'>
                                    <path d='M19.7,4.3c-0.4-0.4-1-0.4-1.4,0L12,10.6L5.7,4.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l6.3,6.3l-6.3,6.3 c-0.4,0.4-0.4,1,0,1.4C4.5,19.9,4.7,20,5,20s0.5-0.1,0.7-0.3l6.3-6.3l6.3,6.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L13.4,12l6.3-6.3C20.1,5.3,20.1,4.7,19.7,4.3z'/>
                                </svg>
                            ) : (
                                <svg className='w-5 text-gray-600' viewBox='0 0 24 24' fill='currentColor'>
                                    <path d='M23,13H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,13,23,13z'/>
                                    <path d='M23,6H1C0.4,6,0,5.6,0,5s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,6,23,6z'/>
                                    <path d='M23,20H1c-0.6,0-1-0.4-1-1s0.4-1,1-1h22c0.6,0,1,0.4,1,1S23.6,20,23,20z'/>
                                </svg>
                            )}
                        </button>
                        {isMenuOpen && (
                            <div className='absolute top-full left-0 w-full bg-white border-t border-gray-200 shadow-lg'>
                                <div className='p-5'>
                                    <nav>
                                        <ul className='space-y-4'>
                                            <li>
                                                <a href='/#features' aria-label='Features' title='Features' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary' onClick={() => { setIsMenuOpen(false) }}>
                                                    Features
                                                </a>
                                            </li>
                                            <li>
                                                <Link to='/contacts' aria-label='Contact' title='Contact' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary' onClick={() => { setIsMenuOpen(false) }}>
                                                    Contact
                                                </Link>
                                            </li>
                                            <li>
                                                <a href='/#pricing' aria-label='Pricing' title='Pricing' className='font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-primary' onClick={() => { setIsMenuOpen(false) }}>
                                                    Pricing
                                                </a>
                                            </li>

                                            <li>
                                                <Link
                                                    to='/contacts'
                                                    className='inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-primary hover:bg-primary-hover focus:shadow-outline focus:outline-none'
                                                    aria-label='Contact us'
                                                    title='Contact us'
                                                    onClick={() => { setIsMenuOpen(false) }}
                                                >
                                                    Contact us
                                                </Link>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}
